import { render, staticRenderFns } from "./InTheNews.vue?vue&type=template&id=cf8fa8d8&scoped=true&"
import script from "./InTheNews.vue?vue&type=script&lang=js&"
export * from "./InTheNews.vue?vue&type=script&lang=js&"
import style0 from "./InTheNews.vue?vue&type=style&index=0&id=cf8fa8d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8fa8d8",
  null
  
)

export default component.exports